// extracted by mini-css-extract-plugin
module.exports =  {"gig-attribute-wrapper":"loh3vDc","gigAttributeWrapper":"loh3vDc","gig-attribute":"eCL5AnF","gigAttribute":"eCL5AnF","attribute-text":"qydCeaD","attributeText":"qydCeaD"};